import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, take } from 'rxjs';
import { SubSection } from '../models/sub-section';

@Injectable({
  providedIn: 'root',
})
export class SubSectionService {
  public constructor(private httpClient: HttpClient) { }

  private readonly apiUrl = '/api/SubSection/';

  private subSectionSubject = new BehaviorSubject<SubSection[] | null>(null);
  subSection$ = this.subSectionSubject.asObservable();

  private initiatorSubSectionSubject = new BehaviorSubject<SubSection | null>(null);
  initiatorSubSection$ = this.initiatorSubSectionSubject.asObservable();

  getSubSections(sectionId: string): void {
    this.httpClient.get<SubSection[]>(this.apiUrl + sectionId + '/get').pipe(take(1)).subscribe({
      next: (result) => this.subSectionSubject.next(result),
      error: (err) => console.error('Ошибка загрузки подсекций', err),
    });
  }

  addSection(subSection: SubSection) {
    this.httpClient.post<SubSection>(this.apiUrl + 'create', subSection).subscribe();
  }

  deleteSection(id: string, sectionId: string): void {
    this.httpClient.delete(this.apiUrl + id + '/delete').subscribe()
  }

  reset() {
    this.subSectionSubject.next(null);
  }

  addLocal(subSection: SubSection, isInitiator: boolean): void {
    const subSections = this.subSectionSubject.value;
    if (!subSections) return;

    this.subSectionSubject.next([...subSections, subSection].sort((a, b) => a.name.localeCompare(b.name)));

    if (isInitiator) {
      this.initiatorSubSectionSubject.next(subSection);
    }
  }

  updateLocal(subSection: SubSection): void {
    const subSections = this.subSectionSubject.value;
    if (!subSections) return;

    this.subSectionSubject.next(
      subSections.map(s => s.id === subSection.id ? subSection : s).sort((a, b) => a.name.localeCompare(b.name)));
  }

  removeLocal(subSectionId: string): void {
    const subSections = this.subSectionSubject.value;
    if (!subSections) return;

    this.subSectionSubject.next(
      subSections.filter(s => s.id !== subSectionId).sort((a, b) => a.name.localeCompare(b.name)));
  }
}
